import { airlineCodeNoDisplayAirline, LateNightDepartureDisplayLanguage } from '@conf/segment-information.config';
import { PostJourneysGetJourneyResponseDataFlightsInner } from 'src/sdk_checkin';

/**
 * 引数で渡されたキャリアコードから、キャリア名称を表示する必要があるキャリアであるかを返却する
 * @param airlineCode
 * @returns 運行キャリア名を表示するキャリアコードに含まれていない場合true、そうでない場合false
 */
export function isDisplayAirline(airlineCode: string) {
  return !airlineCodeNoDisplayAirline.includes(airlineCode);
}

export function isSameAirlineCode(segment?: PostJourneysGetJourneyResponseDataFlightsInner) {
  return segment?.marketingAirlineCode === segment?.operatingAirlineCode;
}

/**
 * 引数で渡された言語から、出発時間を前日併記で表示する必要があるかを判定する
 * @param lang
 * @returns 言語コードがja、cn、tw, hk, koの場合はtrue、そうでない場合はfalse
 */
export function isDisplayLateNightDepartureLanguage(lang: string) {
  return LateNightDepartureDisplayLanguage.includes(lang);
}

/**
 * 指定された2つの日付型文字列を日付単位で比較し、日付の大小を返す
 * @param date1　 比較する日付1
 * @param date2 比較する日付2
 * @returns 計算した日付差 -1,0,1
 */
export function getDateDifference(date1: string, date2: string): Number {
  const dateTimeList1 = date1.split('T');
  const dateTimeList2 = date2.split('T');
  const dateTime1 = new Date(dateTimeList1[0]).getTime();
  const dateTime2 = new Date(dateTimeList2[0]).getTime();
  if (dateTime1 < dateTime2) {
    return 1;
  } else if (dateTime1 > dateTime2) {
    return -1;
  } else {
    return 0;
  }
}

/**
 * キャビンクラスを表示する必要があるかどうかを返却する
 * @param operatingType 便種別
 * @param marketingAirlineCode 販売キャリアコード
 * @param nhGroupMarketingList NHグループ販売キャリアリスト
 * @param routeType 国内際区分
 * @returns 国際線セグメントがNH便名NHグループ運航便の場合true、それ以外の場合false
 */
export function isDisplayCabinClass(
  operatingType: PostJourneysGetJourneyResponseDataFlightsInner.OperatingTypeEnum | undefined,
  operatingAirlineCode: string,
  marketingAirlineCode: string,
  nhGroupMarketingList: string[],
  nhGroupOperatingList: string[],
  routeType: PostJourneysGetJourneyResponseDataFlightsInner.RouteTypeEnum
) {
  const isNhGroupMarketing = nhGroupMarketingList.includes(marketingAirlineCode);
  const isNhGroupOperating = nhGroupOperatingList.includes(operatingAirlineCode);

  return (
    (isNhGroupOperating &&
      isNhGroupMarketing &&
      routeType === PostJourneysGetJourneyResponseDataFlightsInner.RouteTypeEnum.Int) ||
    (isNhGroupMarketing && routeType === PostJourneysGetJourneyResponseDataFlightsInner.RouteTypeEnum.Dom) ||
    operatingType === PostJourneysGetJourneyResponseDataFlightsInner.OperatingTypeEnum.NhGroupOperating
  );
}

/**
 * 当該セグメントがSuffix便であるかどうかを判定する
 * Suffix便かどうかは、便番号の末尾が'D'であるかで判定する
 * @param 販売便番号
 * @returns 販売便番号の末尾がDであればtrue、それ以外であればfalse
 */
export function isSuffixSegment(marketingFlightNumber: string) {
  return marketingFlightNumber.endsWith('D');
}

/**
 * 当該セグメントがIATCIであるかどうかを判定する
 * @param セグメント情報
 * @returns IATCIであればtrue, それ以外であればfalse
 */
export function isIATCI(segment: PostJourneysGetJourneyResponseDataFlightsInner) {
  return segment.isIATCI === true;
}

/**
 * dateTimeの文字列を、yyyy-MM-dd形式に変換する。
 * 具体的な変換方法としては、日付と時刻がTで区切られているため、Tでsplitして前半を返すようにする
 * @param yyyy-MM-ddTHH:mm:ss 形式の文字列
 * @returns yyyy-MM-dd形式の文字列
 */
export function convertDateTimeToDate(dateTime: string) {
  return dateTime.split('T')[0];
}
